import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cart from '../../components/blocks/Cart';
import Spinner from '../../components/common/Spinner';
import PageLayout from '../../components/common/PageLayout';
import { getCartVariants, sendOrder, setQuantityItem, deleteOrderLine } from '../../store/actions/cart';

function CartContainer(props) {
  const getVariants = props.getCartVariants;
  const {
    sendOrder,
    hasStore,
    variants,
    setQuantityItem,
    deleteOrderLine,
    retailerSuppliers,
    retailerId,
    isAdmin,
    errorMessage,
  } = props;

  useEffect(() => {
    getVariants();
  }, [getVariants]);

  if (props.isLoading) {
    return <Spinner />;
  }

  return (
    <PageLayout>
      <Cart
        variants={variants}
        retailerSuppliers={retailerSuppliers}
        sendOrder={sendOrder}
        setQuantityItem={setQuantityItem}
        deleteOrderLine={deleteOrderLine}
        retailerId={retailerId}
        hasStore={hasStore}
        isAdmin={isAdmin}
        errorMessage={errorMessage}
      />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { variants, isLoading, stores, error: errorMessage } = state.cart;
  const { user, retailerId, retailerSuppliers } = state.role;

  let isAdmin;

  if (user) {
    const retailerPermission = user.retailers.find(({ id }) => id === retailerId);
    if (retailerPermission) {
      isAdmin = retailerPermission.administration_permission === 'write';
    }
  }

  return {
    variants,
    retailerId,
    retailerSuppliers,
    isLoading,
    hasStore: stores && stores.length > 0,
    isAdmin: !!isAdmin,
    errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCartVariants: () => dispatch(getCartVariants()),
  sendOrder: (...args) => dispatch(sendOrder(...args)),
  setQuantityItem: (value, sku) => dispatch(setQuantityItem(value, sku)),
  deleteOrderLine: (sku) => dispatch(deleteOrderLine(sku)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);

CartContainer.propTypes = {
  getCartVariants: PropTypes.func.isRequired,
  sendOrder: PropTypes.func.isRequired,
  retailerId: PropTypes.number.isRequired,
  setQuantityItem: PropTypes.func.isRequired,
  deleteOrderLine: PropTypes.func.isRequired,
  retailerSuppliers: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasStore: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};
